<script lang="ts">
  const { dark }: { dark?: boolean } = $props();
</script>

<svg class={["loading-spinner", ...(dark ? ["dark"] : [])].join(" ")} viewBox="0 0 40 40">
  <circle class="track" cx="20" cy="20" r="17.5" pathLength="100" stroke-width="5px" />
  <circle class="spinner" cx="20" cy="20" r="17.5" pathLength="100" stroke-width="5px" />
</svg>
